import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ReceiveRoofItelTaskAttemptSchema = z.object({
  type: z.literal(TaskType.RECEIVE_ROOF_ITEL),
  fileIds: z.array(z.string()).min(1),
});
